import React from 'react';

// Only rendered when data-debug="1" is set on the embed container. In normal
// operation a failed fetch renders nothing so the host page is undisturbed.
export default function EmbedError({ message }) {
  return (
    <div
      style={{
        margin: '12px',
        padding: '14px 16px',
        border: '1px solid rgba(220,38,38,0.35)',
        borderRadius: '10px',
        background: 'rgba(254,242,242,0.9)',
        color: '#b91c1c',
        fontSize: '13px',
        lineHeight: 1.5,
        fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',
      }}
    >
      {`Famewall Embed: ${message || 'Testimonials could not be loaded.'}`}
    </div>
  );
}
